import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, combineLatest, tap, filter } from 'rxjs';
import { AppConfigService } from '../../services/app-config.service';
import { TenantService } from '../../services/tenant.service';
import { DrawerService } from '../../services/drawer.service';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.sass']
})
export class NavbarComponent implements OnInit {
  addTriggered = false;

  constructor(
    public drawerService: DrawerService,
    public tenantService: TenantService,
    public auth: AuthService,
    public userService: UsersService,
    public appConfigService: AppConfigService
  ) {}

  setUpUserVoice(): Observable<any> {
    const uv = document.createElement('script');
    uv.type = 'text/javascript';
    uv.async = true;
    uv.src = `//widget.uservoice.com/${this.appConfigService.userVoiceId}.js}`;
    const s = document.getElementsByTagName('script')[0];
    if (s.parentNode) {
      s.parentNode.insertBefore(uv, s);
    }

    return new Observable((observer) => {
      uv.onload = () => {
        const userVoice = (window as any).UserVoice || [];
        observer.next(userVoice);
      };
    });
  }

  ngOnInit(): void {
    combineLatest([
      this.auth.user$,
      this.setUpUserVoice(),
      this.userService.getUserVoiceToken()
    ])
      .pipe(
        filter(
          ([userAuth, userVoice, token]) => !!userAuth && !!token && !!userVoice
        ),
        tap(([userAuth, userVoice, token]) => {
          (window as any).UserVoice.push([
            'set',
            {
              sso: token
            }
          ]);

          if (!this.addTriggered) {
            (window as any).UserVoice.push([
              'addTrigger',
              '#user-voice',
              {
                forum_id: this.appConfigService.userVoiceForumId,
                mode: 'feedback',
                accent_color: '#448dd6',
                trigger_color: 'white',
                trigger_background_color: 'rgba(46,49,51,0.6)'
              }
            ]);
            this.addTriggered = true;
          }
        })
      )
      .subscribe();
  }
}
